// import React from "react";
// import ImageUploader from "react-images-upload";

// export const SingleImageReusableComponent = ({ title, smallTitle, onDrop }) => {
//   return (
//     <React.Fragment>
//       <div className="file_upload mt-3">
//         <div className="file-lable-text">
//           <label>{title}</label>
//           <p>{smallTitle}</p>
//         </div>
//         <ImageUploader
//           withLabel={false}
//           withIcon={false}
//           withPreview={true}
//           buttonText={<i className="fa fa-plus" style={{ color: "#fff" }}></i>}
//           onChange={onDrop}
//           imgExtension={[".jpg", ".gif", ".png", ".jpeg"]}
//           maxFileSize={5242880}
//           singleImage={true}
//         />
//       </div>
//     </React.Fragment>
//   );
// };
// export default SingleImageReusableComponent;

import React from "react";
import { Image, Form } from "react-bootstrap";
import { SRLWrapper } from "simple-react-lightbox";
import ProgressBar from "react-bootstrap/ProgressBar";
import CloseIcon from "@material-ui/icons/Close";
import ImageCrop from "./ImageCrop/ImageCrop";

export const SingleImageReusableComponent = ({
  title,
  smallTitle,
  onChange,
  file,
  resetFile,
  onFocusOut,
  name,
  error,
  checkCondition,
  loader,
  combined,
  onCompleteCrop,
  onCancelCrop,
  thumbnail,
}) => {
  const options = {
    settings: {
      autoplaySpeed: 3000,
      disableKeyboardControls: false,
      disablePanzoom: false,
      disableWheelControls: false,
      hideControlsAfter: 3000,
      lightboxTransitionSpeed: 0.6,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(0, 0, 0, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 200],
      slideTransitionSpeed: 0.6,
      slideTransitionTimingFunction: "linear",
    },
    buttons: {
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
    caption: {
      showCaption: false,
    },
    thumbnails: {
      showThumbnails: false,
    },
    progressBar: {
      showProgressBar: false,
    },
  };
  return (
    <React.Fragment>
      <div className="file_upload mt-3">
        <div className="file-lable-text">
          <label>{title}</label>
          <p>{smallTitle}</p>
        </div>
        <div className="d-flex flex-wrap">
          {checkCondition === false ? null : (
            <div className="enUploadBox">
              <Image
                src={require("../../../assets/images/UserManagement/uploadImg.svg")}
                alt="uploadImg"
                title="uploadImg"
                fluid
              />
              <input
                type="file"
                name={name}
                onBlur={onFocusOut}
                id="file"
                accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                onChange={onChange}
              />
            </div>
          )}

          <div
            // className="newChain_addthree m-0"
            style={{ position: "relative" }}
          >
            {/* mx-3 */}
            {!file || file === null ? null : (
              <div className="position-relative newChain_addtwo p-2">
                <SRLWrapper options={options}>
                  {typeof file === "string" && file !== "" && (
                    <Image
                      src={file}
                      className="img-fluid single-image-show-after-upload"
                      style={{ height: "75px", width: "100%" }}
                      alt="photo"
                    />
                  )}
                  {typeof file === "object" && file.name && (
                    <ImageCrop
                      src={file}
                      combined={combined}
                      onCompleteCrop={onCompleteCrop}
                      onCancelCrop={onCancelCrop}
                      thumbnail={thumbnail}
                    />
                  )}
                  {/*  */}
                </SRLWrapper>
                {checkCondition === false ? null : (
                  <div
                    className="remove-button-css remove-button-css-align remove-button-css-two-image-upload"
                    onClick={() => {
                      resetFile();
                    }}
                  >
                    {/* <Image
                      src={require("../../../assets/images/Icon/remove.png")}
                      fluid
                      className="remove-button-image img-fluid"
                    /> */}
                    <CloseIcon
                      style={{
                        color: "#fff",
                        background: "#f85032",
                        fontSize: 18,
                        borderRadius: 50,
                        padding: 1,
                      }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {loader ? (
          <ProgressBar animated variant="success" label="Uplaoding" now={100} />
        ) : null}
        <Form.Text className="text-muted input-component-bottom">
          {error ? (
            <div className="text-danger text-capitalize">{error}</div>
          ) : null}
        </Form.Text>
      </div>
    </React.Fragment>
  );
};

export default SingleImageReusableComponent;
